import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const MainPage = () => {
  const navigate=useNavigate()
  const location=useLocation()
  const currentLocation=location.pathname.split('/')?.[3]

  return (
    <section className='position-relative'>
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <h2 className="page-tittle">Campaign</h2>
          <hr />
        </header>
        <nav className="mb-3">
          <div className="nav nav-tabs tabber" id="nav-tab" role="tablist">
            <button className={` ${currentLocation === 'contact' ? 'activeNav' : 'unActiveNav'} border-0`} onClick={() => { navigate('contact') }}>
              Contact
            </button>
            <button className={` ${currentLocation === 'group' ? 'activeNav' : 'unActiveNav'} border-0`} onClick={() => { navigate('group') }} >
              Group
            </button>
            <button className={` ${currentLocation === 'campaign' ? 'activeNav' : 'unActiveNav'} border-0`} onClick={() => { navigate('campaign') }} >
              Campaign
            </button>
          </div>
        </nav>
        <Outlet/>
      </div>
    </section>
  )
}

export default MainPage